import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms'
@Directive({
  selector: '[appNumeros]'
})
export class NumerosDirective {

  constructor(public control:NgControl) { }

  @HostListener('input', ['$event']) changeForm() {
    const cadena = this.control.control.value.replace(/[^0-9]/g, '');
    this.control.control.setValue(cadena)
  }
}
